// editor strings (fr). Machine-drafted — review with a native speaker before launch.
const editor = {
	editor: {
		// Header / top toolbar
		backToDashboard: 'Retour au tableau de bord',
		cardTitlePlaceholder: 'Titre de la carte',
		previewCard: 'Aperçu de la carte',
		invite: 'Inviter',
		sendCard: 'Envoyer la carte',
		saveChanges: 'Enregistrer les modifications',

		// Left sidebar tool labels
		badgeNew: 'NOUVEAU',
		changeCover: 'Changer la couverture',
		coverType: 'Couverture',
		coverStatic: 'Image fixe',
		coverDynamic: 'Dynamique',
		coverStaticConfirm: 'Passer à une couverture fixe ? Les textes, logos et balises de la couverture seront supprimés.',
		coverRemoveImage: 'Retirer l\'image de couverture',
		addMessage: 'Ajouter un message',
		addImage: 'Ajouter une image',
		aiImage: 'Image IA',
		background: 'Arrière-plan',
		addGif: 'Ajouter un GIF',
		addVideo: 'Ajouter une vidéo',
		music: 'Musique',
		callToAction: "Appel à l'action",

		// Autosave notification
		autosaveSaving: 'Enregistrement ...',
		autosaveSaved: 'Enregistré automatiquement',
		autosaveError: "Erreur d'enregistrement automatique !",
		close: 'Fermer',

		// Font tool
		chooseColor: 'Choisir une couleur',
		selectFont: 'Choisir une police',
		showMore: 'Afficher plus',
		showLess: 'Afficher moins',

		// Text effect tool
		effects: 'Effets',
		fontStyles: 'Styles de police',
		effectNone: 'Aucun',
		effectHollow: 'Creux',
		effectLift: 'Relief',
		effectShadow: 'Ombre',
		effectNeon: 'Néon',
		effectGlitch: 'Glitch',
		effectSplice: 'Découpe',
		backToFontTool: "Retour à l'outil de police",

		// Image tool
		searchPhotos: 'Rechercher des photos',
		search: 'Rechercher',
		designOnCanva: 'Concevoir sur Canva',
		uploadImage: 'Téléverser une image',
		uploading: 'Téléversement...',

		// GIF tool
		searchUpload: 'Rechercher / Téléverser',
		embedLink: 'Insérer un lien',
		searchGifs: 'Rechercher des GIF',
		uploadGif: 'Téléverser un GIF',
		trending: 'Tendances',
		pasteGifUrl: "Collez l'URL du GIF ici...",
		loading: 'Chargement...',
		addGifButton: 'Ajouter un GIF',
		gifUrlHint: 'Collez un lien direct vers un fichier GIF (se terminant par .gif) ou une URL d’image prise en charge.',

		// Video tool
		videoTabAdd: 'Ajouter une vidéo',
		videoTabRecord: 'Enregistrer',
		videoTabMyVideos: 'Mes vidéos',
		videoAddHint: 'Collez une URL YouTube, Vimeo ou vidéo directe, ou téléversez un fichier vidéo.',
		videoUrlPlaceholder: 'https://...',
		add: 'Ajouter',
		uploadVideo: 'Téléverser une vidéo',
		videoSupportedHint: 'Pris en charge : YouTube, Vimeo, téléversements MP4/WebM.',
		noVideosUploaded: 'Aucune vidéo téléversée pour le moment.',
		confirmDeleteVideo: 'Êtes-vous sûr de vouloir supprimer cette vidéo ?',
		videoPreview: 'Aperçu de la vidéo',
		deleteSelectedVideo: 'Supprimer la vidéo sélectionnée',

		// Music tool
		musicUploaded: 'Téléversé',
		musicLibrary: 'Bibliothèque',
		musicUpload: 'Téléverser',
		searchTracks: 'Rechercher des pistes...',
		loadingTracks: 'Chargement des pistes...',
		noTracksFound: 'Aucune piste trouvée',
		dropAudioHere: 'Déposez le fichier audio ici',
		audioFormats: 'MP3, WAV ou OGG',
		moodHappy: 'Joyeux',
		moodSad: 'Triste',
		moodRelaxing: 'Relaxant',
		moodEnergetic: 'Énergique',
		moodRomantic: 'Romantique',
		moodEpic: 'Épique',
		moodChill: 'Détente',
		moodUplifting: 'Motivant',

		// Call to action panel
		createCta: "Créer un appel à l'action",
		buttonLink: 'Lien du bouton (URL)',
		buttonText: 'Texte du bouton',
		buttonColor: 'Couleur du bouton',
		textColor: 'Couleur du texte',
		borderStyle: 'Style de bordure',

		// Video card sidebar panel
		videoCard: 'Carte vidéo',
		videoCardIntro:
			'Concevez la couverture de votre carte, puis partagez le lien d’invitation pour que les contributeurs puissent enregistrer ou téléverser leurs messages vidéo.',
		shareInviteLink: 'Partager le lien d’invitation',
		shareInviteLinkHint:
			'Copiez ce lien et envoyez-le à toute personne que vous souhaitez voir contribuer une vidéo à cette carte.',
		linkCopied: 'Lien copié !',
		copyInviteLink: 'Copier le lien d’invitation',
		howItWorks: 'Comment ça marche',
		videoCardStep1: "Concevez la couverture et les pages de votre carte à l'aide de l'éditeur",
		videoCardStep2: "Enregistrez et copiez le lien d'invitation à partager avec les contributeurs",
		videoCardStep3: 'Les contributeurs enregistrent ou téléversent des vidéos via le lien',
		videoCardStep4:
			'Accédez au tableau de bord Cartes vidéo pour configurer les paramètres, examiner les soumissions, générer et envoyer',
		videoCardManageHint:
			'Gérez les soumissions, définissez des échéances, réorganisez les vidéos et générez la vidéo finale depuis le',
		videoCardsDashboard: 'Cartes vidéo',

		// Merge tags panel
		createWorkflowTitle: 'Créer un flux de travail avec des intégrations',
		beta: 'Bêta',
		createWorkflowDesc:
			'Connectez vos applications en quelques minutes. Créez n’importe quel flux de travail dont vous rêvez avec Zapier ou Pabbly Connect. Automatisez vos processus et intégrez-les à vos applications préférées pour plus de concentration et moins de frustration.',
		createZapierWorkflow: 'Créer un flux Zapier',
		createPabblyWorkflow: 'Créer un flux Pabbly Connect',
		or: 'OU',
		sendViaEmailPlatform: 'Envoyer via votre plateforme de messagerie',
		personalisedLinkDesc:
			'Obtenez un lien personnalisé avec des balises de fusion formatées pour votre plateforme de messagerie (SendGrid, Brevo, HubSpot, Mailchimp).',
		getPersonalisedLink: 'Obtenir un lien personnalisé',
		getEmbedCode: "Obtenir le code d'intégration pour e-mail",
		customizeAndSendBulk: 'Personnaliser et envoyer en masse',
		customizeAndSendBulkDesc:
			'Avec %{app}, vous pouvez personnaliser vos cartes. Créez une carte et envoyez-la à tous vos contacts en utilisant des balises de fusion.',
		uploadCsv: 'Téléverser un CSV',
		selectFromLists: 'SÉLECTIONNER DANS LES LISTES',
		clearAll: 'Tout effacer',
		noCsvUploaded: "Vous n'avez pas encore téléversé de fichier csv. Commencez par téléverser un fichier depuis votre appareil.",
		deleteCsv: 'Supprimer le CSV',

		// Upload CSV modal
		uploadCsvTitle: 'Téléversez votre fichier CSV ici',
		uploadCsvDesc:
			'Une fois votre CSV téléversé, %{app} associera vos données aux balises de fusion disponibles ainsi qu’aux balises personnalisées pour vous permettre de personnaliser chaque carte et d’envoyer des cartes à autant de contacts que vous le souhaitez',
		cancel: 'Annuler',
		next: 'Suivant',

		// Invite collaborators panel
		backToMain: 'Retour à l’accueil',
		inviteCollaborators: 'Inviter des collaborateurs',
		tabDirectLink: 'Lien direct',
		tabEmail: 'E-mail',
		tabSocial: 'Réseaux sociaux',

		// Text fallback / merge tag toolbar
		mergeTags: 'Balises de fusion',
		newMergeTag: 'Nouvelle balise',
		fromSource: 'De %{source}',
		csv: 'csv',
		// Card format + invitation event tool
		format: {
			tool: 'Format et événement',
			title: 'Format de la carte',
			single: 'Page unique',
			singleDesc: 'Une seule page.',
			double: 'Recto et verso',
			doubleDesc: 'Deux pages : un recto et un verso.',
			folded: 'Carte pliée (4 pages)',
			foldedDesc: 'Carte classique à plusieurs pages.',
			front: 'Recto',
			back: 'Verso',
			card: 'Carte',
			pageLimit: 'Ce format de carte autorise au maximum %{max} page(s).',
			tooManyPages: 'Cette carte a plus de pages que ne le permet un format de %{max} page(s). Supprimez-en d’abord.',
		},
		event: {
			toggle: 'Cette carte est une invitation',
			eventTitle: 'Titre de l’événement',
			start: 'Début',
			end: 'Fin (facultatif)',
			timezone: 'Fuseau horaire',
			inPerson: 'En personne',
			online: 'En ligne',
			address: 'Adresse',
			hostNote: 'Mot de l’hôte',
			allowGuests: 'Autoriser les invités (+1)',
			save: 'Enregistrer l’invitation',
			saved: 'Invitation enregistrée',
			errorTitle: 'Erreur',
			saveFailed: 'Impossible d’enregistrer les modifications',
			errors: {
				titleRequired: 'Saisissez un titre pour l’événement.',
				titleTooLong: 'Le titre doit contenir 200 caractères maximum.',
				startRequired: 'Choisissez une date et une heure de début.',
				endInvalid: 'Saisissez une date et une heure de fin valides.',
				endBeforeStart: 'La fin ne peut pas précéder le début.',
				timezoneInvalid: 'Choisissez un fuseau horaire valide.',
				urlInvalid: 'Saisissez un lien http(s) valide.',
				hostNoteTooLong: 'Le mot doit contenir 1000 caractères maximum.',
			},
		},
	} as Record<string, any>,
};
export default editor;
